import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import clsx from 'clsx';
import React from 'react';
import LinkTo from '@di-shared/features/navigate/LinkTo';
import {ROUTE_PATHS} from '@di-shared/routes';
import useTirePressure from '@di-shared/features/diag/tire/useTirePressure';
import {emitEventLog} from '@di-shared/features/analytics';
import useCcWebviewUtilsHelper from '@di-shared/features/common/useCcWebviewUtilsHelper';

export interface VehicleTireKrProps {
  vin: string;
}

function VehicleTireKr({vin}: VehicleTireKrProps) {
  const {t} = useInferableTranslation();
  const {isInspectionRequired, registeredTire} = useTirePressure(vin);

  return (
    <li className="car_diagnosis_item">
      <LinkTo
        className="car_diagnosis_link"
        to={ROUTE_PATHS.DIAG_TIRE.getFullPath(vin)}
        onClickBypass={() =>
          emitEventLog({
            event: 'vehicle_status_check',
            interaction_type: 'view tire pressure',
            click_text: t('T30002'),
            click_location: 'body',
          })
        }
      >
        <div className="section_container">
          <strong className="car_diagnosis_title">{t('T30002')}</strong>
          {registeredTire && (
            <div className="badge_box">
              <span
                className={clsx('badge badge_20px', {
                  badge_basic_container: !isInspectionRequired,
                  badge_container_red: isInspectionRequired,
                })}
              >
                {isInspectionRequired ? t('T20080') : t('T20079')}
              </span>
            </div>
          )}
          <span
            className={clsx('ic', {
              ic_tire_good: !registeredTire || !isInspectionRequired,
              ic_tire_warning: registeredTire && isInspectionRequired,
            })}
          />
        </div>
      </LinkTo>
    </li>
  );
}

VehicleTireKr.Error = VehicleTireError;
export default VehicleTireKr;

function VehicleTireError() {
  const {t} = useInferableTranslation();
  const {openAlert} = useCcWebviewUtilsHelper();
  return (
    <li className="car_diagnosis_item">
      <div
        role={'button'}
        className="car_diagnosis_link"
        onClick={() =>
          openAlert({
            title: t('T30002'),
            message: t('T30358') + '\n' + t('T10160_$tel', {tel: import.meta.env.VITE_EMERGENCY_TEL_BRAND}),
          })
        }
      >
        <div className="section_container">
          <strong className="car_diagnosis_title">{t('T30002')}</strong>

          <span className="ic ic_tire_warning" />
        </div>
      </div>
    </li>
  );
}
